import React, { useState, useEffect, useRef, useCallback } from 'react';
import { Form, Typography, Row, Col, Card, Space, Checkbox, } from 'antd';
import dayjs from 'dayjs';
import { useErrorLogger } from '../../../utils.js';
import { useDispatch } from 'react-redux';
import { getOptionsByPath } from '../../../utilsdata';
import moment from 'moment';
import { Field } from 'formik';
import { useSelector } from 'react-redux';
import { InputField, DatePickerField, SelectInput } from '../../../blueplanitUtils/InputField.jsx';
import { fetchEmployeeClientsThunk } from '../../../Slices/orderSlice.jsx';
import { fetchEmployeesByRoute } from '../../../Slices/Employeeaccessslice.js';
import {
    REQUEST_INFO,
    EDIT_REQUEST_PRIORITY,
    EDIT_REQUEST_STATUS,
    CLIENT_INFO,
    CLIENT_SERVICESASSIGNED
} from '../../../Dropdownmanager.jsx';
import { EmailTrackMails } from '../Outlook/EmailTrackTab.jsx';

const RequestInformation = (props) => {
    const { RequestInfo, handleChange, values, setFieldValue } = props;

    const dispatch = useDispatch();
    const { logError } = useErrorLogger();

    const loginUser = useSelector((state) => state?.loginUserInfo?.loginUserDetails);
    const clientsData = useSelector((state) => state?.orders?.getAllClients);
    const NestedDatabucket = useSelector((state) => state.dataBucket.NestedDatabucket);
    // Route-filtered employees for Assign To dropdown (only employees with /request route access)
    const routeFilteredEmployees = useSelector((state) => state.employeeAccess?.routeFilteredEmployees?.["/request"] || []);
    const allEmployees = useSelector((state) => state.employee.AllEmployees);
    // Include current assignee in dropdown even if they no longer have route access (existing records untouched)
    const employeeOptions = (() => {
        const filtered = [...routeFilteredEmployees];
        const currentAssignTo = values?.assignTo;
        if (currentAssignTo && !filtered.some(e => `${e.firstname} ${e.lastname}` === currentAssignTo)) {
            const match = allEmployees?.find(e => `${e.firstname} ${e.lastname}` === currentAssignTo);
            if (match) filtered.push(match);
        }
        return filtered;
    })();

    const [timestamp, setTimestamp] = useState();
    const userOverrodeDueDate = useRef(false);
    const userUpdatedStartDate = useRef(false);

    const userid = loginUser?.id;

    useEffect(() => {
        if (userid) {
            dispatch(fetchEmployeeClientsThunk(userid));
        }
        dispatch(fetchEmployeesByRoute({ route: "/request" }));
    }, [dispatch, userid]);

    const getDateTime = (timeValue) => moment(timeValue).format('DD/MM/YYYY hh:mm A');

    const getDueTime = (timeValue, typeValue) => {
        const formattedDateTime = moment(timeValue).format('YYYY-MM-DD HH:mm:ss');
        return moment(formattedDateTime).add(typeValue, 'hours').format('YYYY-MM-DD HH:mm:ss');
    };

    const getDueTimePriority = (emailText) => {
        let hours = 24;
        const hasRushOrUrgent =
            emailText.toLowerCase().includes("rush") ||
            emailText.toLowerCase().includes("urgent");

        if (hasRushOrUrgent) hours = 2;
        return hours;
    };

    useEffect(() => {
        try {
            let priorityValue = getDueTimePriority(RequestInfo?.subject + ' ' + RequestInfo?.html);

            if (values.priority === null) {
                if (priorityValue === 2) setFieldValue('priority', 'Rush');
                else if (priorityValue === 24) setFieldValue('priority', 'On Demand');
                else setFieldValue('priority', 'Bulk');
            }
        } catch (error) {
            logError("RequestInformation", "useEffect-set the priority value", error.message);
        }
    }, [RequestInfo?.html, RequestInfo?.subject, logError, setFieldValue, values.priority]);

    const responseStatusHandler = (value) => {
        setFieldValue('responseStatus', value);
    };

    const requestStatusHandler = (value) => {
        setFieldValue('requestStatus', value);
        if (value === 'Completed') {
            setFieldValue('completedDate', dayjs(new Date()).valueOf());
        }
    };

    const GetDueDateTemp = (values, RequestInfo) => {
        try {
            let dateValue = values?.responseDate ? values?.responseDate : values.date;
            if (values.priority === null) {
                getDateTime(
                    getDueTime(
                        parseInt(values.date),
                        getDueTimePriority(RequestInfo?.subject + ' ' + RequestInfo?.html)
                    )
                );
            } else {
                if (values.priority === 'Rush')
                    dateValue = getDateTime(getDueTime(parseInt(values.date), 2));
                else if (values.priority === 'On Demand')
                    dateValue = getDateTime(getDueTime(parseInt(values.date), 24));
                else if (values.priority === 'Bulk')
                    dateValue = getDateTime(getDueTime(parseInt(values.date), 48));
            }

            return dateValue;
        } catch (error) {
            logError("RequestInformation", "GetDueDateTemp for date and time", error.message);
        }
    };

    const updateDueDateBasedOnPriority = (startDate) => {
        const priority = values.priority;
        let newDueDate;

        if (startDate) {
            switch (priority) {
                case 'Rush':
                    newDueDate = dayjs(startDate).add(2, 'hours');
                    break;
                case 'On Demand':
                    newDueDate = dayjs(startDate).add(24, 'hours');
                    break;
                case 'Bulk':
                    newDueDate = dayjs(startDate).add(48, 'hours');
                    break;
                default:
                    newDueDate = dayjs(startDate).add(1, 'days');
            }
            setFieldValue('dueDate', newDueDate);
        }
    };

    const calculateDueDate = (startDate, hoursToAdd) => {
        return dayjs(parseInt(startDate))
            .add(hoursToAdd, 'hours')
            .format('YYYY-MM-DD HH:mm:ss');
    };

    const calculatePriorityDueDate = (startDate, hoursToAdd) => {
        const parsed = dayjs(startDate);
        return parsed.isValid() ? parsed.add(hoursToAdd, 'hour') : null;
    };

    const getPriorityHours = (priority, subject, html) => {
        if (!priority) {
            const hasRushOrUrgent = (subject + ' ' + html).toLowerCase().includes("rush") ||
                (subject + ' ' + html).toLowerCase().includes("urgent");
            return hasRushOrUrgent ? 2 : 24;
        }
        switch (priority) {
            case 'Rush':
                return 2;
            case 'On Demand':
                return 24;
            case 'Bulk':
                return 48;
            default:
                return 24;
        }
    };

    const AutoDateChanger = (priority, startDate, subject, html) => {
        if (!userOverrodeDueDate.current && startDate) {
            const priorityHours = getPriorityHours(priority, subject, html);

            if (userUpdatedStartDate.current) {
                const parsedStartDate = dayjs(startDate);
                if (!parsedStartDate.isValid()) return;

                const calculatedDueDate = calculatePriorityDueDate(parsedStartDate, priorityHours);

                if (calculatedDueDate?.isValid()) {
                    const timestamp = calculatedDueDate.valueOf();
                    setTimestamp(timestamp);
                    setFieldValue('dueDate', calculatedDueDate);
                }
            } else {
                const calculatedDueDate = calculateDueDate(startDate, priorityHours);
                if (calculatedDueDate) {
                    const timestamp = dayjs(calculatedDueDate).valueOf();
                    setTimestamp(timestamp);
                    setFieldValue('dueDate', dayjs(timestamp));
                }
            }
        }
    };

    useEffect(() => {
        const isNew = !RequestInfo?.dueDate;

        if (isNew) {
            const startDate = values.startDate?.$d || RequestInfo?.startDate || RequestInfo?.date;
            AutoDateChanger(values.priority, startDate, RequestInfo?.subject, RequestInfo?.html);
        }
        userOverrodeDueDate.current = false;
    }, [RequestInfo, values.priority, values.startDate]);

    const DateCondition = useCallback(() => {
        try {
            let minDate;
            if (values.startDate > RequestInfo?.dueDate) {
                minDate = dayjs(values.startDate);
            } else if (RequestInfo?.startDate) {
                minDate = dayjs(parseInt(RequestInfo?.startDate));
            } else {
                minDate = dayjs(parseInt(RequestInfo?.date));
            }
            return minDate;
        } catch (error) {
            logError("RequestInformation", "Dateconditions", error.message);
        }
    }, [values.startDate, RequestInfo, logError]);

    useEffect(() => {
        DateCondition();
    }, [DateCondition]);

    const handleDueDateChange = (date) => {
        setFieldValue('dueDate', date);
        userOverrodeDueDate.current = true;
    };

    const assignHandler = (isChecked) => {
        try {
            setFieldValue('Assign', isChecked);
            if (isChecked) {
                setFieldValue('requestStatus', 'In Progress');
                setFieldValue('assignedTo', loginUser?.firstname);
            } else {
                setFieldValue('requestStatus', 'Open');
                setFieldValue('assignedTo', '');
            }
        } catch (error) {
            logError("RequestInformation", "assignhandler", error.message);
        }
    };


    const getAssignToUsers = (usersList) => {
        const usersListFormatted = [];
        for (let i = 0; i < usersList?.length; i++) {
            usersListFormatted.push({
                key: i,
                value: usersList[i].firstname + " " + usersList[i].lastname,
            });
        }
        return usersListFormatted;
    };

    const startDateHandler = (date) => {
        userUpdatedStartDate.current = true;
        setFieldValue('startDate', date);
        updateDueDateBasedOnPriority(date);
    };

    const handleKeyDown = (e) => {
        let value = e.target.value.replace(/[^\d/]/g, '');
        if (value.length >= 10 && e.key !== "Backspace") {
            e.preventDefault();
            return;
        }

        value = value
            .replace(/^(\d{2})(\d)$/g, '$1/$2')
            .replace(/^(\d{2}\/\d{2})(\d{1,4})$/g, '$1/$2');

        e.target.value = value;
    };

    const handleSwitchChange = (checked) => {
        setFieldValue("instructions", checked);
    };
    return (
        <>
            <Card
                className="request-card"
                style={{ height: "auto" }}
                bodyStyle={{ padding: 12 }}
                title={
                    <div className="request-header" style={{ display: "flex", flexDirection: "column", gap: 10 }}>
                        <div className="request-header-grid">

                            {/* Title */}
                            <div className="request-title-block" style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                <Typography.Title level={5} style={{ margin: 0, fontWeight: 600 }}>
                                    Request Information
                                </Typography.Title>
                            </div>
                            {/* RequestId */}
                            <div>
                                <label style={{ fontSize: 12, fontWeight: 400 }}>RequestId</label>
                                <span style={{ fontWeight: "bold", fontSize: 12 }}>{RequestInfo?.requestId}</span>
                            </div>
                            {/* Received Date */}
                            <div>
                                <label style={{ fontSize: 12, fontWeight: 400 }}>Received Date</label>
                                <span style={{ fontWeight: "bold", fontSize: 12, }}>
                                    {getDateTime(parseInt(values.date))}
                                </span>
                            </div>
                            {/* Due Date */}
                            <div>
                                <label style={{ fontSize: 12, fontWeight: 400 }}>Due Date</label>
                                <span style={{ fontWeight: "bold", fontSize: 12, }}>
                                    {GetDueDateTemp(values, RequestInfo)}
                                </span>
                            </div>
                            {/* Response Date */}
                            <div>
                                <label style={{ fontSize: 12, fontWeight: 400 }}>Response Date</label>
                                <span style={{ fontWeight: "bold", fontSize: 12, }}>
                                    {values?.responseDate ? getDateTime(parseInt(values?.responseDate)) : "_"}
                                </span>
                            </div>


                            {/* Client Name */}
                            <div className="client-name-block">
                                <span className="client-name-label">Client Name</span>
                                <SelectInput
                                    className="client-name-select"
                                    label=""
                                    name="clientName"
                                    style={{ marginTop:'20px', width:220}}
                                    value={values.clientName}
                                    onChange={(value) =>
                                        handleChange({ target: { name: "clientName", value } })
                                    }
                                    options={clientsData?.map((item) => ({
                                        value: item.NameOfClient,
                                        label: item.NameOfClient,
                                    }))}
                                    showSearch
                                />
                            </div>
                        </div>
                    </div>
                }
            >
                {/* MAIN CONTAINER */}
                <div className="panel-container request-panels" style={{ marginBottom: 12 }}>

                    {/* LEFT PANEL – ASSIGN */}
                    <div className="left-panel assign-panel" style={{ border: "1px solid #E3E6EB", borderRadius: 6, padding: 8}}>
                        <div className="assign-to-row">
                            <span className="panel-label">UnAssign</span>
                            <Checkbox
                                className="assign-checkbox"
                                checked={values.Assign}
                                onChange={(e) => assignHandler(e.target.checked)}
                                style={{ marginTop: '-12px' }}
                            />
                        </div>

                        <div className="assign-body">

                            <div className="assign-to-row">
                                <span className="panel-label">Assigned To</span>
                                <div className="assigned-to-input">
                                    <InputField
                                        label=""
                                        name="assignedTo"
                                        value={values.assignedTo}
                                        disabled
                                        onChange={handleChange}
                                    />
                                </div>
                            </div>

                            <div className="assign-select-row">
                                <span className="panel-label">Assign To</span>
                                <div className="assign-to-select">
                                    <SelectInput
                                        label=""
                                        showSearch
                                        style={{ width:130}}
                                        options={getAssignToUsers(employeeOptions)}
                                        value={values.assignTo}
                                        onChange={(value) => {
                                            setFieldValue("assignTo", value);
                                            setFieldValue("assignedTo", value);
                                        }}
                                    />
                                </div>
                            </div>

                        </div>

                    </div>

                    {/* MIDDLE PANEL – REQUEST DATA */}
                    <div className="middle-panel request-middle-panel" style={{ border: "1px solid #E3E6EB", borderRadius: 6, padding: 12 }}>

                        <div className="field-row start-date-row">
                            <span className="panel-label" style={{ marginLeft:'-10px'}}>Start Date Override</span>
                            <div className="field-input">
                                <DatePickerField
                                    name="startDate"
                                    showTime
                                    value={(() => {
                                        const ts = values.startDate || values?.responseDate || RequestInfo?.date;
                                        if (!ts || isNaN(ts)) return null;
                                        const d = dayjs(Number(ts));
                                        return d.isValid() ? d : null;
                                    })()}
                                    onChange={startDateHandler}
                                    format="DD/MM/YYYY hh:mm A"
                                    allowClear={false}
                                />
                            </div>
                        </div>

                        <div className="field-row status-row">
                            <span className="panel-label">Status</span>
                            <div className="field-input">
                                <SelectInput
                                    value={values?.requestStatus || "Open"}
                                    name="requestStatus"
                                    onChange={requestStatusHandler}
                                    options={getOptionsByPath(NestedDatabucket, [REQUEST_INFO, EDIT_REQUEST_STATUS])}
                                />
                            </div>
                        </div>

                        <div className="field-row due-date-row">
                            <span className="panel-label" style={{ marginLeft:'-10px'}}>Due Date Override</span>
                            <div className="field-input">
                                <DatePickerField
                                    name="dueDate"
                                    showTime
                                    value={dayjs(values.dueDate || parseInt(timestamp))}
                                    onChange={handleDueDateChange}
                                    format="DD/MM/YYYY hh:mm A"
                                    allowClear={false}
                                />
                            </div>
                        </div>

                        <div className="field-row process-type-row">
                            <span className="panel-label">Process Type</span>
                            <div className="field-input">
                                <SelectInput
                                    value={values.processType}
                                    name="processType"
                                    onChange={(value) => handleChange({ target: { name: "processType", value } })}
                                    options={getOptionsByPath(NestedDatabucket, [CLIENT_INFO, CLIENT_SERVICESASSIGNED])}
                                />
                            </div>
                        </div>

                        <div className="field-row completed-date-row">
                            <span className="panel-label" style={{ marginLeft:'-10px'}}>Completed Date</span>
                            <div className="field-input">
                                <Field name="completedDate">
                                    {({ field }) => {
                                        const parsedValue = parseInt(field.value);
                                        const dateValue = parsedValue && !isNaN(parsedValue) ? dayjs(parsedValue) : null;
                                        return (
                                            <DatePickerField
                                                name="completedDate"
                                                showTime
                                                value={dateValue}
                                                onChange={(date) =>
                                                    field.onChange({ target: { value: date?.valueOf().toString() || "", name: field.name } })
                                                }
                                                format="DD/MM/YYYY hh:mm A"
                                                allowClear={false}
                                            />
                                        );
                                    }}
                                </Field>
                            </div>
                        </div>

                        <div className="field-row priority-row">
                            <span className="panel-label">Priority</span>
                            <div className="field-input">
                                <SelectInput
                                    value={values?.priority}
                                    name="priority"
                                    onChange={(value) => {
                                        handleChange({ target: { name: "priority", value } });
                                        const startDate = values.startDate || RequestInfo?.startDate || RequestInfo?.date;
                                        AutoDateChanger(value, startDate, RequestInfo?.subject, RequestInfo?.html);
                                    }}
                                    options={getOptionsByPath(NestedDatabucket, [REQUEST_INFO, EDIT_REQUEST_PRIORITY])}
                                />
                            </div>
                        </div>

                    </div>
                    {/* RIGHT PANEL – MAIL DETAILS */}
                    <div className="right-panel mail-panel" style={{ border: "1px solid #E3E6EB", borderRadius: 6, padding: 12 }}>

                        <div className="mail-panel-inner">

                            <div className="mail-inputs">

                                <div className="mail-row">
                                    <span className="mail-label">Subject</span>
                                    <InputField
                                        label=""
                                        name="subject"
                                        value={values.subject}
                                        onChange={handleChange}
                                    />
                                </div>

                                <div className="mail-row">
                                    <span className="mail-label">From</span>
                                    <InputField
                                        label=""
                                        type="email"
                                        name="from"
                                        value={values.from}
                                        onChange={handleChange}
                                    />
                                </div>

                                <div className="mail-row">
                                    <span className="mail-label">To</span>
                                    <InputField
                                        label=""
                                        name="to"
                                        value={values.to}
                                        onChange={handleChange}
                                    />
                                </div>

                            </div>

                            <div className="mail-checkboxes">
                                <div className="mail-checkbox-row">
                                    <span className="mail-checkbox-label">Pending</span>
                                    <Checkbox
                                        checked={values.fromPending}
                                        disabled
                                    />
                                </div>
                                <div className="mail-checkbox-row">
                                    <span className="mail-checkbox-label">Mail Status</span>
                                    <Checkbox
                                        checked={values.responseStatus}
                                        onChange={(e) => responseStatusHandler(e.target.checked)}
                                    />
                                </div>

                                <div className="mail-checkbox-row">
                                    <span className="mail-checkbox-label">Instructions</span>
                                    <Checkbox
                                        checked={values.instructions}
                                        onChange={(e) => handleSwitchChange(e.target.checked)}
                                    />
                                </div>
                            </div>

                        </div>
                    </div>


                </div>

                {/* EMAIL BODY */}
                <div className="email-body-panel" style={{ border: "1px solid #E3E6EB", borderRadius: 6, background: "#fff", padding: 10 }}>
                    {RequestInfo?.emailTrack?.length > 0 ? (
                        <EmailTrackMails emailRows={RequestInfo?.emailTrack} clientMail={RequestInfo?.to} />
                    ) : (
                        <div
                            className="email-html-body"
                            dangerouslySetInnerHTML={{ __html: RequestInfo?.html || RequestInfo?.body }}
                        />
                    )}
                </div>
            </Card>

        </>
    );
};

export default RequestInformation;
